import {
  getHelperTextProps,
  HelperTextPopover,
} from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { CheckBox } from '@bambi/component-library/src/components/inputs/CheckBox/CheckBox';
import type { CheckedState } from '@bambi/component-library/src/components/inputs/CheckBox/CheckBox';

import type { FormFieldProps } from './FormField';

export function FormFieldCheckbox<T>({
  inputProps,
  label,
  helperText,
  value,
  onChange = (checked: CheckedState) => {},
  className = '',
  disabled = false,
}: FormFieldProps<T>) {
  const { popoverProps } = getHelperTextProps({
    helperText,
    label,
  });
  return (
    <>
      <div className={'flex items-center gap-2 ' + className}>
        <div>
          <CheckBox
            id={inputProps.id}
            checked={value as CheckedState}
            onCheckedChange={onChange}
            disabled={disabled}
          />
        </div>
        <label
          htmlFor={inputProps.id}
          className="text-sm font-medium text-gray-700"
        >
          {label}
        </label>
        {popoverProps && <HelperTextPopover {...popoverProps} />}
      </div>
    </>
  );
}
